import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
    //   {
    //     path: '/',
    //     name: 'Home',
    //     component: Home
    //   },
    {
        path: '/research-integrity',
        name: 'homepage',
        component: () => import('../views/research_integrity/research-integrity/homepage.vue'),
        meta: {
            title: '科研诚信',
            icon: 'dashboard'
        },
        children:[
            // 失信单位
            {
                path: 'reporting',
                name: 'reporting',
                component: () => import('../views/research_integrity/research-integrity/reporting.vue'),
                meta: {
                title: '举报须知',
                },
            },
            // 失信个人
            {
                path: 'personreporting',
                name: 'reporting',
                component: () => import('../views/research_integrity/research-integrity/unitreporting.vue'),
                meta: {
                title: '举报须知',
                },
            },
            {
                path: 'tabulation',
                name: 'tabulation',
                component: () => import('../views/research_integrity/research-integrity/tabulation.vue'),
                meta: {
                title: '举报列表',
                },
            },
            {
                path: 'realname',
                name: 'realname',
                component: () => import('../views/research_integrity/research-integrity/realname.vue'),
                meta: {
                title: '实名举报',
                },
            },
            {
                path: 'anonymous',
                name: 'anonymous',
                component: () => import('../views/research_integrity/research-integrity/anonymous.vue'),
                meta: {
                title: '匿名举报',
                },
            },
        ]
    },

    //创新平台相关
    //转换需求列表
    {
        path: '/platform/fruit-transfer/list',
        name: 'fruit-transfer',
        component: () => import('@/views/platform/fruit-transfer/fruit-transfer'),
        meta: {
            title: '成果转化',
            isTab: true,
            icon: 'dashboard'
        }
    },
    //转换需求详情
    {
        path: '/platform/fruit-transfer/detail',
        name: 'fruit-transfer-detail',
        component: () => import('@/views/platform/fruit-transfer/fruit-transfer-detail'),
        meta: {
            title: '成果转化详情',
            isTab: true,
            icon: 'dashboard'
        }
    },
    //互动交流-信件列表
    {
        path: '/platform/letter/list',
        name: 'interact',
        component: () => import('@/views/platform/interact/interact-list'),
        meta: {
            title: '互动交流',
            isTab: true,
            icon: 'dashboard'
        }
    },
    //互动交流-信件留言发布
    {
        path: '/platform/letter/publish',
        name: 'interact',
        component: () => import('@/views/platform/interact/interact-publish'),
        meta: {
            title: '互动交流',
            isTab: true,
            icon: 'dashboard'
        }
    },
    //互动交流-信件详情
    {
        path: '/platform/letter/detail',
        name: 'interact',
        component: () => import('@/views/platform/interact/interact-detail'),
        meta: {
            title: '互动交流',
            isTab: true,
            icon: 'dashboard'
        }
    },
    //验证
    {
        path: '/tech-manage/acceptance/acceptance-cert',
        name: 'acceptanceCert',
        component: () => import('@/views/tech-manage/acceptance/acceptance-cert'),
        meta: {
            title: '互动交流',
            isTab: true,
            icon: 'dashboard'
        }
    },
    // 需求征集
    {
        path: '/collect/public-declare',
        name: 'publicDeclare',
        component: () => import('@/views/collect/public-declare'),
        meta: {
            title: '社会公众填报',
            isTab: true,
            icon: 'dashboard'
        }
    },
    // 需求征集-游客查询
    {
        path: '/collect/annoymous-query',
        name: 'annoymousQuery',
        component: () => import('@/views/collect/annoymous-query'),
        meta: {
            title: '游客查询',
            isTab: true,
            icon: 'dashboard'
        }
    },
    // 项目申报-公示项目查询
    {
        path: '/declare/projectList',
        name: 'projectList',
        component: () => import('@/views/declare/projectList'),
        meta: {
            title: '项目公示查询',
            isTab: true,
            icon: 'dashboard'
        }
    },
    //   {
    //     path: '/about',
    //     name: 'About',
    //     // route level code-splitting
    //     // this generates a separate chunk (about.[hash].js) for this route
    //     // which is lazy-loaded when the route is visited.
    //     component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    //   }
    // 专家评审-专家签名页面
    {
        path: '/review/signature-page',
        name: 'signaturePage',
        component: () => import('@/views/review/electronicSignature'),
        meta: {
            title: '评审结果录入-专家签名',
            isTab: true,
            icon: 'dashboard'
        }
    },
    // 专家评审-专家签名页面
    {
        path: '/review/expert-exit-page',
        name: 'expertExitPage',
        component: () => import('@/views/review/expertExitReview'),
        meta: {
            title: '专家退评',
            isTab: true,
            icon: 'dashboard'
        }
    },
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

export default router
